import React from 'react';
import UploadPanel from './UploadPanel';
import VideoPreviewGrid from './VideoPreviewGrid';
import ProcessingSidebar from './ProcessingSidebar';
import DownloadStartedModal from './DownloadStartedModal';
import SubscribeRequiredModal from './SubscribeRequiredModal';

const NavigationCenter = ({
  user,
  isUserSignedIn,
  handleLogout,
  setIsUserSignedIn,
  setUser,
  setDoctors,
  setInsurances,
  setBodilyParts,
  setOriginalDoctors,
  videoProcessing,
  hasStartedProcessing,
}) => {
  return (
    <div className="w-full">
      <div className="mb-6">
        <p className="text-xs font-black uppercase tracking-[0.32em] text-cyan-300">
          Processing Center
        </p>

        <h2 className="mt-2 text-3xl font-black tracking-tight text-white sm:text-4xl">
          Video Workspace
        </h2>

        <p className="mt-3 max-w-5xl text-sm leading-6 text-slate-300">
          Upload your original video on the left. Once processing finishes, the translated subtitle version appears on the right.
        </p>
      </div>

      <UploadPanel
        user={user}
        isUserSignedIn={isUserSignedIn}
        handleLogout={handleLogout}
        setIsUserSignedIn={setIsUserSignedIn}
        setUser={setUser}
        setDoctors={setDoctors}
        setInsurances={setInsurances}
        setBodilyParts={setBodilyParts}
        setOriginalDoctors={setOriginalDoctors}
        selectedFile={videoProcessing.selectedFile}
        isUploading={videoProcessing.isUploading}
        handleFileChange={videoProcessing.handleFileChange}
        handleClearSelectedFile={videoProcessing.handleClearSelectedFile}
        fileInputResetKey={videoProcessing.fileInputResetKey}
        handleUploadAndGenerateSubtitles={videoProcessing.handleUploadAndGenerateSubtitles}
        videoValidationError={videoProcessing.videoValidationError}
        selectedVideoDuration={videoProcessing.selectedVideoDuration}
        maxBetaVideoDurationSeconds={videoProcessing.maxBetaVideoDurationSeconds}
        formatVideoDuration={videoProcessing.formatVideoDuration}
      />

      {hasStartedProcessing && (
        <ProcessingSidebar
          className="mb-6 2xl:hidden"
          loadingSteps={videoProcessing.loadingSteps}
          isUploading={videoProcessing.isUploading}
          isProcessingFinished={videoProcessing.isProcessingFinished}
          downloadToken={videoProcessing.downloadToken}
          selectedFile={videoProcessing.selectedFile}
          handleDownloadVideo={videoProcessing.handleDownloadVideo}
          buttonText={videoProcessing.buttonText}
          countdown={videoProcessing.countdown}
          formatCountdown={videoProcessing.formatCountdown}
        />
      )}

      <VideoPreviewGrid
        user={user}
        isUploading={videoProcessing.isUploading}
        handleFileChange={videoProcessing.handleFileChange}
        fileInputResetKey={videoProcessing.fileInputResetKey}
        originalVideoURL={videoProcessing.originalVideoURL}
        processedVideoURL={videoProcessing.processedVideoURL}
        subtitlesURL={videoProcessing.subtitlesURL}
        originalVideoRef={videoProcessing.originalVideoRef}
        processedVideoRef={videoProcessing.processedVideoRef}
        toggleFullscreen={videoProcessing.toggleFullscreen}
        handleDownloadVideo={videoProcessing.handleDownloadVideo}
        countdown={videoProcessing.countdown}
        formatCountdown={videoProcessing.formatCountdown}
      />

      {videoProcessing.showDownloadModal && (
        <DownloadStartedModal
          closeModal={() => videoProcessing.setShowDownloadModal(false)}
        />
      )}

      <SubscribeRequiredModal
        isOpen={videoProcessing.showSubscribeModal}
        onClose={() => videoProcessing.setShowSubscribeModal(false)}
        onSubscribeClick={videoProcessing.handleSubscribeClick}
        title={videoProcessing.subscribeModalTitle}
        message={videoProcessing.subscribeModalMessage}
      />
    </div>
  );
};

export default NavigationCenter;